import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionChannelLogoContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  height: ${80 * Screen.widthRatio}px;
  right: ${140 * Screen.widthRatio}px;
  top: ${40 * Screen.widthRatio}px;
  position: absolute;
`;

export default DescriptionChannelLogoContainer;
